import { useEffect } from 'react';

import { trackQuestionViewed } from '@/features/advisor-onboarding/questionnaire/lib/analytics';

export function useQuestionViewAnalytics(questionId: string): void {
  useEffect(() => {
    trackQuestionViewed(questionId);
  }, [questionId]);
}
